var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBeanzlogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_69",
    "data-name": "Group 69",
    xmlns: "http://www.w3.org/2000/svg",
    width: 210,
    height: 52,
    viewBox: "0 0 210 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_6358",
    "data-name": "Path 6358",
    d: "M0,0H9.673C19.615,0,24.16,3.725,24.16,13.206c0,6.692-1.97,10.418-7.031,12.024,5.643,1.316,7.837,4.975,7.837,11.823C24.966,47.271,20.354,52,10.255,52H0ZM9.583,22.308c5.284,0,7.7-2.565,7.7-8.1,0-5.979-2.239-8.031-7.7-8.031H7.031V22.308Zm-.2,23.066c6.068,0,8.531-1.762,8.531-8.388s-2.485-8.923-8.419-8.923H7.031V45.352Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6359",
    "data-name": "Path 6359",
    d: "M20.86,0H41.729V6.269H27.891V21.728H40.564v6.2H27.891V45.508H41.729V52H20.86Z",
    transform: "translate(25.863)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6360",
    "data-name": "Path 6360",
    d: "M50.456,0h6.583L69.264,52h-7.1L59.681,41.805H47.746L45.328,52h-7.1ZM49.067,35.961h9.36l-4.68-22.576Z",
    transform: "translate(47.4)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6361",
    "data-name": "Path 6361",
    d: "M61,0h6.516L81.354,36.117V0h6.717V52H81.354L67.561,15.616V52H61Z",
    transform: "translate(75.631)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6362",
    "data-name": "Path 6362",
    d: "M98.848,6.2H84.338V0h24.093L91.66,45.508h15.316V52H81.92Z",
    transform: "translate(101.569)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeanzlogo);
export default __webpack_public_path__ + "static/media/Beanz logo.8e391a2e63177dabc930772e4a28cbdd.svg";
export { ForwardRef as ReactComponent };